import type { Bootstrap } from '@zg-rentals/rp-bootstrap-base';
import { useEffectOnce } from 'react-use';

export { RpErrorBoundary } from './components/RpErrorBoundary';

export { BootstrapBrowser, BootstrapBrowserBuilder, Bootstrap } from './BootstrapBrowser';

type Export = { bootstrap: Bootstrap } | { default: Bootstrap };
export const useBootstrap = (loader: () => Promise<Export> | Export) => {
  useEffectOnce(() => {
    Promise.resolve(loader())
      .then((instance) => ('bootstrap' in instance ? instance.bootstrap : instance.default))
      .then((instance) => instance.register())
      .catch(() => null);
  });
};
